import React, { useState } from 'react';
import TableWrapServerSide from '@/components/ui/tables/TableWrapServerSide';
import IsLoadingNotFound from '@/components/ui/tables/IsLoadingNotFound';
import Moment from 'moment/moment';

const DataTable = ({ isLoading, tableColumn, dataSource, totalRecord, dataFilter, onChangePage, handleDrawerOpen, deleteRecord, paymentGatewayMap }) => {
    const getPaymentMethodName = (paymentMethodId) => {
        if (!paymentMethodId) return 'Cash';
        return paymentGatewayMap[paymentMethodId] || paymentMethodId || 'Cash';
    };

    return (
        <TableWrapServerSide tableColumnList={tableColumn} totalDataCount={totalRecord} initialPage={dataFilter?.page} onChangePage={onChangePage} per_page={dataFilter?.limit}>
            {dataSource.length > 0 ? (
                dataSource.map((data) => (
                    <tr className="db-table-body-tr" key={data._id}>
                        <td className="db-table-body-td">{data._id}</td>
                        <td className="db-table-body-td">{Moment(data?.createdAt).format('Y-M-D hh:mm:ss')}</td>
                        <td className="db-table-body-td">{getPaymentMethodName(data.payment_method)}</td>
                        <td className="db-table-body-td">{data.order_id}</td>
                        <td className="db-table-body-td">{data.amount}</td>
                    </tr>
                ))
            ) : (
                <IsLoadingNotFound isLoading={isLoading} colSpan={tableColumn.length} />
            )}
        </TableWrapServerSide>
    );
};

export default DataTable;
